import { Badge } from '@mantine/core';
import type { MouseEvent, ReactNode } from 'react';

type TaskBadgeVariant = 'default' | 'light';

type TaskBadgeProps = {
  children: ReactNode;
  icon: ReactNode;
  variant?: TaskBadgeVariant;
  color?: string;
  onClick?: (e: MouseEvent) => void;
  'aria-label'?: string;
};

export const TaskBadge = ({
  children,
  icon,
  variant = 'default',
  color,
  onClick,
  'aria-label': ariaLabel,
}: TaskBadgeProps) => {
  const interactive = onClick !== undefined;

  return (
    <Badge
      size="lg"
      fw={400}
      styles={{ label: { textTransform: 'none' }, root: { padding: '2px 4px' } }}
      variant={variant}
      radius={6}
      leftSection={icon}
      color={color}
      onClick={onClick}
      aria-label={ariaLabel}
      component={interactive ? 'button' : 'div'}
      type={interactive ? 'button' : undefined}
      style={{ cursor: interactive ? 'pointer' : undefined }}
    >
      {children}
    </Badge>
  );
};
